<template>
  <v-btn
    v-bind="{ ...$attrs }"
    v-on="{ ...$listeners }"
    class="text-caption font-weight-bold"
    color="accent"
    text
  >
    <div v-if="right">
      {{ name }}
      <v-icon right>{{ icon }}</v-icon>
    </div>
    <div v-else>
      <v-icon left>{{ icon }}</v-icon>
      {{ name }}
    </div>
  </v-btn>
</template>

<script>
export default {
  name: "CreateButton",
  props: {
    icon: {
      type: String
    },
    name: {
      type: String
    },
    right: {
      type: Boolean,
      defaut: false
    }
  }
}
</script>
